import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import { useSelector } from 'react-redux';

import { setCustomerPhone } from 'actions';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { IState } from 'typings';
import {
  IGetCorrectedPhoneNumberQuery,
  IGetCorrectedPhoneNumberQueryVariables,
} from 'typings/GraphQL';
import isMaskedPhoneInputValid from 'utils/isMaskedPhoneInputValid';

const getCorrectedPhoneNumberQuery = loader(
  '../../queries/getCorrectedPhoneNumber.graphql',
);

export const usePhoneId = () => {
  const dispatch = useThunkDispatch();
  const { customerPhone } = useSelector((state: IState) => ({
    customerPhone: state.userInput.customerPhone,
  }));

  const { id, number } = customerPhone;
  const hasPhoneId = !!id;
  const shouldQueryForPhone = !hasPhoneId && isMaskedPhoneInputValid(number);

  const { data: getCorrectedPhoneNumberData } = useQuery<
    IGetCorrectedPhoneNumberQuery,
    IGetCorrectedPhoneNumberQueryVariables
  >(getCorrectedPhoneNumberQuery, {
    fetchPolicy: 'cache-and-network',
    onCompleted: (data) => {
      const phone = data?.getCorrectedPhoneNumber?.phone;

      if (phone) {
        dispatch(setCustomerPhone(phone));
      }
    },
    skip: !shouldQueryForPhone,
    variables: {
      phoneNumber: number || '',
    },
  });

  const resultId =
    getCorrectedPhoneNumberData?.getCorrectedPhoneNumber?.phone?.id || id;

  return resultId;
};
